export const AUTHENTICATED_USER = 'AUTHENTICATED_USER';
export const UNAUTHENTICATED_USER = 'UNAUTHENTICATED_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';


// WEBPACK FOOTER //
// ./src/containers/auth/types.js